import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Planet, List, X } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/why-photopulse", label: "Why PhotoPulse?" },
  { to: "/explore", label: "Explore" },
  { to: "/photos", label: "Places" },
  { to: "/about", label: "How it works" },
  { to: "/faq", label: "FAQ" },
];

const Brand = () => (
  <Link to="/" data-testid="public-brand" className="flex items-center gap-2">
    <Planet size={24} weight="fill" className="text-[#F27A54]" />
    <span className="font-display text-lg font-black tracking-tight">
      PHOTO<span className="text-[#F27A54]">PULSE</span>.pro
    </span>
  </Link>
);

export default function PublicLayout({ children }) {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <header className="sticky top-0 z-40 border-b border-border bg-white/85 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
          <Brand />
          <nav className="hidden items-center gap-7 md:flex">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} data-testid={`public-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={({ isActive }) => `text-sm font-semibold transition-colors ${isActive ? "text-[#F27A54]" : "text-zinc-600 hover:text-[#F27A54]"}`}>
                {n.label}
              </NavLink>
            ))}
            {!user && <Link to="/login" data-testid="public-signin" className="text-sm font-semibold text-zinc-600 hover:text-[#F27A54]">Sign in</Link>}
            {user ? (
              <Link to="/dashboard" data-testid="public-dashboard"
                className="rounded-full bg-[#F27A54] px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-[#d9633f]">
                My Dashboard
              </Link>
            ) : (
              <Link to="/login" data-testid="public-contribute"
                className="rounded-full bg-[#F27A54] px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-[#d9633f]">
                Contribute
              </Link>
            )}
          </nav>
          <button className="md:hidden" onClick={() => setOpen((o) => !o)} data-testid="public-menu-toggle" aria-label="Menu">
            {open ? <X size={24} weight="bold" /> : <List size={24} weight="bold" />}
          </button>
        </div>
        {open && (
          <div className="border-t border-border bg-white px-5 py-3 md:hidden">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)}
                className="block py-2 text-sm font-semibold text-zinc-700">{n.label}</NavLink>
            ))}
            <div className="mt-2 flex gap-2">
              <Link to="/login" onClick={() => setOpen(false)} className="flex-1 rounded-full border border-border py-2 text-center text-sm font-semibold">Sign in</Link>
              {user ? (
                <Link to="/dashboard" onClick={() => setOpen(false)} className="flex-1 rounded-full bg-[#F27A54] py-2 text-center text-sm font-bold text-white">My Dashboard</Link>
              ) : (
                <Link to="/login" onClick={() => setOpen(false)} className="flex-1 rounded-full bg-[#F27A54] py-2 text-center text-sm font-bold text-white">Contribute</Link>
              )}
            </div>
          </div>
        )}
      </header>

      <main>{children}</main>

      <footer className="mt-20 border-t border-border bg-white">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-5 py-8 sm:flex-row">
          <Brand />
          <div className="flex flex-wrap items-center gap-5 text-sm text-zinc-500">
            <Link to="/explore" className="hover:text-[#F27A54]">Explore</Link>
            <Link to="/about" className="hover:text-[#F27A54]">How it works</Link>
            <Link to="/faq" className="hover:text-[#F27A54]">FAQ</Link>
            <Link to="/terms" className="hover:text-[#F27A54]">Terms</Link>
            <Link to="/privacy" className="hover:text-[#F27A54]">Privacy</Link>
          </div>
          <p className="text-xs text-zinc-400">© {new Date().getFullYear()} PhotoPulse.pro</p>
        </div>
      </footer>
    </div>
  );
}
